import { PropsWithChildren } from 'react'

const TableFootBar = ({ children }: PropsWithChildren) => {
    return (
        <div className='ted-ui-TableFooter'>
            {children}
        </div>
    )
}

export default TableFootBar